/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Is_Member_CooperativeInputs */

const vi_grower_is_member_cooperative = /** @type {(inputs: Grower_Is_Member_CooperativeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thành viên hợp tác xã`)
};

/**

* @param {Grower_Is_Member_CooperativeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_is_member_cooperative = /** @type {((inputs?: Grower_Is_Member_CooperativeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Is_Member_CooperativeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_is_member_cooperative(inputs)
});